import { Chip, Stack, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import PlatformIcon, { TypeSocialIcon } from 'src/components/Icons/PlatformIcon';

// Components
import Table from 'src/components/Table';
import RouterLinkNoUnderline from 'src/components/common/RouterLinkNoUnderline';
import { EmptyText } from 'src/utils/constants/config';

// Utilities
import { convertToStartCase, getColorPercentMatch, renderTextOrDefault } from 'src/utils/helpers/stringHelpers';

const ContactByRole = ({ title, listContact }: { title: string; listContact: Array<IContactCompanyManagerAI> }) => {
  const configColumn: ConfigCell<IContactCompanyManagerAI>[] = [
    {
      id: 'full_name',
      disablePadding: true,
      label: 'Full Name',
      cell: (row: IContactCompanyManagerAI) => {
        return (
          <Typography variant="body2" color="text.primary" fontWeight="bold">
            {convertToStartCase(row.name || EmptyText)}
          </Typography>
        );
      },
    },
    {
      id: 'title',
      disablePadding: false,
      label: 'Job Title',
      cell: (row: IContactCompanyManagerAI) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {convertToStartCase(row?.position || EmptyText)}
          </Typography>
        );
      },
    },
    {
      id: 'linkedin',
      disablePadding: false,
      label: 'LinkedIn',
      cell: (row: IContactCompanyManagerAI) => {
        if (isEmpty(row.linkedin)) {
          return (
            <Typography color={'text.secondary'} variant="body2">
              {EmptyText}
            </Typography>
          );
        } else {
          return (
            <Stack alignItems={'center'} direction={'row'} spacing={1}>
              <PlatformIcon id={TypeSocialIcon.LinkedIn} sx={{ fontSize: 'medium', fill: 'disabled' }} />
              <RouterLinkNoUnderline to={row.linkedin || ''} color="secondary.primary" target="_blank">
                {row.linkedin}
              </RouterLinkNoUnderline>
            </Stack>
          );
        }
      },
    },
    {
      id: 'twitter',
      disablePadding: false,
      label: 'Twitter',
      cell: (row: IContactCompanyManagerAI) => {
        if (isEmpty(row.twitter)) {
          return (
            <Typography color={'text.secondary'} variant="body2">
              {EmptyText}
            </Typography>
          );
        } else {
          return (
            <Stack alignItems={'center'} direction={'row'} spacing={1}>
              <PlatformIcon id={TypeSocialIcon.Twitter} sx={{ fontSize: 'medium', fill: 'disabled' }} />
              <RouterLinkNoUnderline
                to={`https://x.com/${row.twitter || ''}`}
                color="secondary.primary"
                target="_blank"
              >
                {row.twitter}
              </RouterLinkNoUnderline>
            </Stack>
          );
        }
      },
    },
    {
      id: 'company_email',
      disablePadding: false,
      label: 'Email',
      cell: (row: IContactCompanyManagerAI) => {
        if (row?.company_email?.value) {
          return (
            <Stack alignItems={'flex-start'} direction={'column'} spacing={1}>
              <Typography color={'text.secondary'} variant="body2">
                {renderTextOrDefault(row?.company_email?.value)}
              </Typography>
              <Chip
                size="small"
                // color="warning"
                color={getColorPercentMatch((row?.company_email?.confidence || 0) * 100)}
                label={`AI_INFERRED ${(row?.company_email?.confidence || 0) * 100}%`}
              />
            </Stack>
          );
        } else {
          return (
            <Typography color={'text.secondary'} variant="body2">
              Not available (no pattern found)
            </Typography>
          );
        }
      },
    },
  ];
  return (
    <Stack spacing={2}>
      <Typography variant="h5" align="left">
        {title}
      </Typography>
      <Table
        data={listContact}
        configColumn={configColumn}
        dataKey="name"
        id={'table-company' + title}
        isPagination={false}
        maxRow={10}
      />
    </Stack>
  );
};

export default ContactByRole;
